const hash = (str) => [...str].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

const initials = (name) => {
  const parts = name.replace(/[^\p{L}\s.]/gu, "").split(/[\s.]+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const SHAPES = [
  <circle key="c" cx="24" cy="24" r="21" />,
  <rect key="r" x="4" y="4" width="40" height="40" rx="14" />,
  <rect key="d" x="8" y="8" width="32" height="32" rx="10" transform="rotate(45 24 24)" />,
];

const PAIRS = [
  ["#7433C1", "#F26DB5"],
  ["#16B8D6", "#7433C1"],
  ["#C64BB4", "#9055E9"],
  ["#9055E9", "#147E9D"],
];

export const Avatar = ({ name, size = 44 }) => {
  const h = hash(name);
  const [from, to] = PAIRS[h % PAIRS.length];
  const gid = `av-${h}`;
  const shape = SHAPES[(h >>> 3) % SHAPES.length];
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} aria-hidden>
      <svg viewBox="0 0 48 48" width={size} height={size} className="absolute inset-0">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={from} />
            <stop offset="1" stopColor={to} />
          </linearGradient>
        </defs>
        <g fill={`url(#${gid})`}>{shape}</g>
        <circle cx={14 + (h % 8)} cy="14" r="4" fill="#fff" opacity="0.28" />
      </svg>
      <span
        className="absolute inset-0 flex items-center justify-center font-display text-white"
        style={{ fontSize: size * 0.3, textShadow: "0 1px 2px rgba(20, 35, 61, 0.45)" }}
      >
        {initials(name)}
      </span>
    </div>
  );
};
